// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F-_X","field":"styles_field__31gUf","fieldCol":"styles_fieldCol__SwoUR","diffCol":"styles_diffCol__YURYt","diff":"styles_diff__3dg40"};